'use strict';

// external imports
import omniclone from 'omniclone';
import {keys} from 'ts-transformer-keys';
import {encode as encodeHtmlEntities} from 'html-entities';

// shared imports
import metaModel from '~/shared/src/utilities/metaModel';
import Status from '~/shared/src/mm/Status';
import ReferencePropertySet from '~/shared/src/mm/ReferencePropertySet';
import Value from '~/shared/src/mm/Value';
import Reference from '~/shared/src/ci/Reference';
import EnumReferenceProperty from '~/shared/src/ci/EnumReferenceProperty';
import LocalizableError from '~/shared/src/base/LocalizableError';
import {
    convertToDate,
    convertValueForType,
    convertValueToString
} from '~/shared/src/utilities/valueConverters';
import {validateValueForType} from '~/shared/src/utilities/valueValidators';
import {ReferencePropertyMetaDataMapping} from '~/shared/src/utilities/modules/data';


// type definitions
export type ReferencePropertyAttributes = {
    id? : number;
    key? : AttributeValue;
    value? : AttributeValue;
    referenceId : number;
    referencePropertySetId : number;
    statusId? : number;
    modifierUserId? : string;
    modificationTime? : string | NDate;
    validatorUserId? : string;
    validationTime? : string | NDate;
    validFromTime? : string | NDate;
    validToTime? : string | NDate;
};
export const referencePropertyAttributes = keys<ReferencePropertyAttributes>() as string[];
export const isReferencePropertyAttributes = ( referencePropoertyAttributesToTest : any ) : referencePropoertyAttributesToTest is ReferencePropertyAttributes => {
    let retVal = false;

    try {
        if ( typeof referencePropoertyAttributesToTest !== 'object' ) {
            throw new Error();
        }

        if ( referencePropoertyAttributesToTest.id !== undefined && ( typeof referencePropoertyAttributesToTest.id !== 'number' || referencePropoertyAttributesToTest.id < 1 ) ) {
            throw new Error();
        }
        // TODO: fix -> not only string! AttriuteValue!!!
        if ( referencePropoertyAttributesToTest.key !== undefined && typeof referencePropoertyAttributesToTest.key !== 'string' ) {
            throw new Error();
        }
        // TODO: fix -> not only string! AttriuteValue!!!
        if ( referencePropoertyAttributesToTest.value !== undefined && typeof referencePropoertyAttributesToTest.value !== 'string' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.referenceId === undefined || typeof referencePropoertyAttributesToTest.referenceId !== 'number' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.referencePropertySetId === undefined || typeof referencePropoertyAttributesToTest.referencePropertySetId !== 'number' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.statusId !== undefined && typeof referencePropoertyAttributesToTest.statusId !== 'number' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.modifierUserId !== undefined && typeof referencePropoertyAttributesToTest.modifierUserId !== 'string' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.modificationTime !== undefined && typeof referencePropoertyAttributesToTest.modificationTime !== 'string' && !( referencePropoertyAttributesToTest.modificationTime instanceof Date ) && referencePropoertyAttributesToTest.modificationTime !== 'null' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.validatorUserId !== undefined && typeof referencePropoertyAttributesToTest.validatorUserId !== 'string' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.validationTime !== undefined && typeof referencePropoertyAttributesToTest.validationTime !== 'string' && !( referencePropoertyAttributesToTest.validationTime instanceof Date ) && referencePropoertyAttributesToTest.validationTime !== 'null' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.validFromTime !== undefined && typeof referencePropoertyAttributesToTest.validFromTime !== 'string' && !( referencePropoertyAttributesToTest.validFromTime instanceof Date ) && referencePropoertyAttributesToTest.validFromTime !== 'null' ) {
            throw new Error();
        }
        if ( referencePropoertyAttributesToTest.validToTime !== undefined && typeof referencePropoertyAttributesToTest.validToTime !== 'string' && !( referencePropoertyAttributesToTest.validToTime instanceof Date ) && referencePropoertyAttributesToTest.validToTime !== 'null' ) {
            throw new Error();
        }

        retVal = true;
    }
    catch ( e ) {
        /*empty*/
    }

    return retVal;
};

export type ReferencePropertyJsonAttributes = Omit<ReferencePropertyAttributes, 'key' | 'value'>
    & Required<Pick<ReferencePropertyAttributes, 'id'>>
    & { key? : string }
    & { value? : string };
export const referencePropertyJsonAttributes = keys<ReferencePropertyJsonAttributes>() as string[];
export const isReferencePropertyJsonAttributes = ( referencePropertyJsonAttributesToTest : any ) : referencePropertyJsonAttributesToTest is ReferencePropertyJsonAttributes => {
    let retVal = false;

    try {
        if ( typeof referencePropertyJsonAttributesToTest !== 'object' ) {
            throw new Error();
        }

        if ( referencePropertyJsonAttributesToTest.id === undefined || typeof referencePropertyJsonAttributesToTest.id !== 'number' ) {
            throw new Error();
        }
        // TODO: fix -> not only string! AttributeValue!!!
        if ( referencePropertyJsonAttributesToTest.key !== undefined && typeof referencePropertyJsonAttributesToTest.key !== 'string' ) {
            throw new Error();
        }
        // TODO: fix -> not only string! AttributeValue!!!
        if ( referencePropertyJsonAttributesToTest.value !== undefined && typeof referencePropertyJsonAttributesToTest.value !== 'string' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.referenceId === undefined || typeof referencePropertyJsonAttributesToTest.referenceId !== 'number' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.referencePropertySetId === undefined || typeof referencePropertyJsonAttributesToTest.referencePropertySetId !== 'number' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.statusId !== undefined && typeof referencePropertyJsonAttributesToTest.statusId !== 'number' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.modifierUserId !== undefined && typeof referencePropertyJsonAttributesToTest.modifierUserId !== 'string' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.modificationTime !== undefined && typeof referencePropertyJsonAttributesToTest.modificationTime !== 'string' && !( referencePropertyJsonAttributesToTest.modificationTime instanceof Date ) && referencePropertyJsonAttributesToTest.modificationTime !== 'null' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.validatorUserId !== undefined && typeof referencePropertyJsonAttributesToTest.validatorUserId !== 'string' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.validationTime !== undefined && typeof referencePropertyJsonAttributesToTest.validationTime !== 'string' && !( referencePropertyJsonAttributesToTest.validationTime instanceof Date ) && referencePropertyJsonAttributesToTest.validationTime !== 'null' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.validFromTime !== undefined && typeof referencePropertyJsonAttributesToTest.validFromTime !== 'string' && !( referencePropertyJsonAttributesToTest.validFromTime instanceof Date ) && referencePropertyJsonAttributesToTest.validFromTime !== 'null' ) {
            throw new Error();
        }
        if ( referencePropertyJsonAttributesToTest.validToTime !== undefined && typeof referencePropertyJsonAttributesToTest.validToTime !== 'string' && !( referencePropertyJsonAttributesToTest.validToTime instanceof Date ) && referencePropertyJsonAttributesToTest.validToTime !== 'null' ) {
            throw new Error();
        }

        retVal = true;
    }
    catch ( e ) {
        /*empty*/
    }

    return retVal;
};

export type ReferencePropertyAttributesSettable = Partial<Pick<ReferencePropertyAttributes, 'key' | 'value' | 'statusId'> & { orderNum : number }>;
export const referencePropertyAttributesSettable = keys<ReferencePropertyAttributesSettable>() as string[];

export type ReferencePropertyAttributesForCreation = Required<Pick<ReferencePropertyAttributes, 'value' | 'referenceId' | 'referencePropertySetId' | 'statusId'>>
    & Partial<Pick<ReferencePropertyAttributes, 'key'>>;
export const referencePropertyAttributesForCreation = keys<ReferencePropertyAttributesForCreation>() as string[];

export type ReferencePropertyAttributesForUpdate = Partial<Pick<ReferencePropertyAttributes, 'key' | 'value' | 'statusId'>>;
export const referencePropertyAttributesForUpdate = keys<ReferencePropertyAttributesForUpdate>() as string[];

/**
 * The ReferenceProperty class.
 */
class ReferenceProperty {

    /**
     * The unique Id counter for Properties
     */
    static uniqueIdCount = -1;


    /*** ATTRIBUTES ********************************************************************************************************************/

    /**
     * The ID of the ReferenceProperty
     */
    protected _id : number;
    get id() {
        return this._id;
    }

    /**
     * The Key of the ReferenceProperty
     * Only applicable if the ReferenceProperty is an enumerated one
     */
    protected _key : AttributeValue = '';
    get key() {
        return this._key;
    }

    set key( key : AttributeValue ) {
        const referencePropertySet = this.referencePropertySet;

        if ( key !== '' && key !== undefined && key !== null ) {
            if ( referencePropertySet.isKeyOrdered && typeof key === 'string' && referencePropertySet.keyFromStringRegExp?.exec( key.trim() ) ) {
                let orderNum : number;

                ( { orderNum, key } = this.getOrderNumAndKey( key.trim() ) );

                if ( orderNum !== this._orderNum ) {
                    this.orderNum = orderNum;
                }
            }
            else if ( typeof key === 'string' ) {
                key = convertValueForType( key.trim(), referencePropertySet.keyType );
            }
        }

        if ( key !== this._key ) {
            this.validateKey( key );

            this.handleModified( 'key', key );

            this._key = key;

            if ( this._parent instanceof EnumReferenceProperty ) {
                this._parent.updatePropertyKey( this );
            }
        }
    }

    get stringKey() : string {
        return ( this.isDeleted() ? 'deleted_' : '' ) + this.referencePropertySet.getStringKey( { key: this._key, orderNum: this._orderNum } );
    }

    /**
     * The Value of the ReferenceProperty
     */
    protected _value : AttributeValue = '';
    get value() {
        return this._value;
    }

    set value( value : AttributeValue ) {
        const referencePropertySet = this.referencePropertySet;

        if ( value !== '' && value !== undefined && value !== null ) {
            if ( referencePropertySet.isValueOrdered && typeof value === 'string' && referencePropertySet.valueFromStringRegExp?.exec( value ) ) {
                let orderNum : number;

                ( { orderNum, value } = this.getOrderNumAndValue( value ) );

                if ( orderNum !== this._orderNum ) {
                    this.orderNum = orderNum;
                }
            }
            else if ( typeof value === 'string' ) {
                value = convertValueForType( value, referencePropertySet.valueType );
            }
        }

        if (
            ( this.referencePropertySet.valueType === 'JSON' && (
                    value !== '' && this._value === ''
                    || JSON.stringify( JSON.parse( value as string ) ) !== JSON.stringify( JSON.parse( this._value as string ) )
                )
            )
            || ( this.referencePropertySet.valueType !== 'JSON' && value !== this._value )
        ) {
            this.validateValue( value );

            this.handleModified( 'value', value );

            this._value = value;
        }
    }

    get stringValue() : string {
        let value = this._value;

        if ( this.referencePropertySet.valueType === 'JSON' ) {
            try {
                value = JSON.stringify( JSON.parse( value as string ) );
            }
            catch ( e ) {
                value = this._value;
            }
        }

        return this.referencePropertySet.getStringValue( { value, orderNum: this._orderNum } );
    }

    protected _orderNum : number = 0;
    get orderNum() {
        return this._orderNum;
    }

    set orderNum( orderNum : number ) {
        if ( orderNum !== this._orderNum ) {
            this.validateOrderNum( orderNum );

            this.handleModified( 'orderNum', orderNum );

            // reorder
            if ( this._parent instanceof EnumReferenceProperty && !this._parent.isReorderingProperties ) {
                this._parent.reorderProperties( this, orderNum );
            }
            else {
                this._orderNum = orderNum;

                if ( this.referencePropertySet.isKeyOrdered && this._parent instanceof EnumReferenceProperty ) {
                    this._parent.updatePropertyKey( this );
                }
            }
        }
    }

    /**
     * The ReferenceId the ReferenceProperty belongs to.
     */
    protected _referenceId : number;
    get referenceId() {
        return this._referenceId;
    }

    /**
     * The ReferencePropertySetId of the Property.
     */
    protected _referencePropertySetId : number;
    get referencePropertySetId() {
        return this._referencePropertySetId;
    }

    /**
     * The StatusID of the Property.
     */
    protected _statusId : number;
    get statusId() : number {
        return this._statusId;
    }

    set statusId( statusId : number ) {
        if ( statusId !== this._statusId ) {
            this.validateStatusId( statusId );

            this.handleModified( 'statusId', statusId );

            this._statusId = statusId;

            if ( this._parent instanceof EnumReferenceProperty ) {
                this._parent.updatePropertyKey( this, this.stringKey );

                // reorder
                if ( this.isDeleted() && !this._parent.isReorderingProperties ) {
                    this._parent.reorderProperties();
                }
            }
        }
    }

    /**
     * The UserID of the last modifier of the Property
     */
    protected _modifierUserId : string = '';
    get modifierUserId() : string {
        return this._modifierUserId;
    }

    /**
     * The last modification date of the Property
     */
    protected _modificationTime : NDate = null;
    get modificationTime() : NDate {
        return this._modificationTime;
    }

    /**
     * The UserID of the validator of the Property
     */
    protected _validatorUserId : string = '';
    get validatorUserId() : string {
        return this._validatorUserId;
    }

    /**
     * The last validation date of the Property
     */
    protected _validationTime : NDate = null;
    get validationTime() : NDate {
        return this._validationTime;
    }

    /**
     * The valid from date of a History-Property
     */
    protected _validFromTime : NDate = null;
    get validFromTime() {
        return this._validFromTime;
    }

    /**
     * The valid to date of a History-Property
     */
    protected _validToTime : NDate = null;
    get validToTime() {
        return this._validToTime;
    }


    /*** ALIASES ***********************************************************************************************************************/

    get status() : Status {
        return metaModel[ this._schema ].getStatus( this._statusId )!;
    }

    /**
     * The ReferencePropertySet of this ReferenceProperty.
     */
    get referencePropertySet() : ReferencePropertySet {
        return metaModel[ this._schema ].getReferencePropertySet( this._referencePropertySetId )!;
    }

    /**
     * The label for a valueSet value
     */
    get valueLabel() : string | undefined {
        return this.referencePropertySet.valueSetId ? metaModel[ this._schema ]?.getValueSetValue( this.referencePropertySet.valueSetId, String( this._value ) )?.label : undefined;
    }


    /*************************************************************************************************************************************/

    /**
     * The Reference or EnumReferenceProperty this Property belongs to
     */
    protected _parent : Reference | EnumReferenceProperty;
    get parent() {
        return this._parent;
    }

    set parent( parent : Reference | EnumReferenceProperty ) {
        if (
            ( this._parent instanceof Reference && parent instanceof Reference )
            || ( this._parent instanceof EnumReferenceProperty && parent instanceof EnumReferenceProperty )
        ) {
            this._parent = parent;
        }
    }

    /**
     * The database schema this Property belongs to
     */
    protected _schema : Schema;
    get schema() {
        return this._schema;
    }

    /**
     * Map containing the modified attributes with their initial values
     */
    protected _attributesModified : Map<keyof ReferencePropertyAttributesSettable, AttributeValue>;
    get attributesModified() {
        return this._attributesModified;
    }

    /**
     *The constructor.
     *
     * @param parent                    The parent Reference or EnumReferenceProperty this belongs to
     * @param attributes                An object containing attribute-value pairs for this
     *
     */
    constructor( parent : Reference | EnumReferenceProperty, attributes : ReferencePropertyAttributes ) {

        if ( attributes.id && attributes.id < 1 ) {
            throw new LocalizableError( 'YN.base.dataObject.common.attributes.validation.id.invalid' );
        }

        if ( attributes.referenceId === 0 ) {
            throw new Error( 'YN.base.dataObject.referenceProperty.attributes.validation.referenceId.isEmpty' );
        }

        if ( attributes.referencePropertySetId === 0 ) {
            throw new Error( 'YN.base.dataObject.referenceProperty.attributes.validation.referencePropertySetId.isEmpty' );
        }

        if ( attributes.referencePropertySetId !== metaModel[ parent.schema ].getReferencePropertySet( attributes.referencePropertySetId )?.id ) {
            throw new LocalizableError(
                'YN.base.dataObject.referenceProperty.attributes.validation.referencePropertySetId.invalid',
                { referencePropertySetId: String( attributes.referencePropertySetId ), schema: parent.schema }
            );
        }

        this._parent = parent;

        this._schema = parent.schema;

        if ( attributes.id ) {
            this._id = attributes.id;
        }
        else {
            this._id = ReferenceProperty.uniqueIdCount--;
        }

        this._referencePropertySetId = attributes.referencePropertySetId;
        this._referenceId = attributes.referenceId;

        const referencePropertySet = this.referencePropertySet;

        this._orderNum = 0;
        if ( referencePropertySet.isEnumerated && attributes.key !== undefined && attributes.key !== null ) {
            let keyToSet : AttributeValue | undefined,
                orderNumToSet : number | undefined;

            if ( referencePropertySet.isKeyOrdered ) {
                if ( typeof attributes.key !== 'string' ) {
                    throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.mustBeStringForKeyOrderedEnum' );
                }

                const { orderNum, key } = this.getOrderNumAndKey( attributes.key.trim() );

                orderNumToSet = orderNum;
                keyToSet = key;
            }
            else if ( typeof attributes.key === 'string' ) {
                keyToSet = convertValueForType( attributes.key.trim(), referencePropertySet.keyType );
            }
            else {
                keyToSet = attributes.key;
            }

            if ( orderNumToSet ) {
                this.validateOrderNum( orderNumToSet );
                this._orderNum = orderNumToSet
            }

            if ( keyToSet !== undefined && keyToSet !== null && keyToSet !== '' ) {
                this.validateKey( keyToSet );
                this._key = keyToSet
            }
        }

        if ( attributes.value !== undefined && attributes.value !== null ) {
            let valueToSet : AttributeValue | undefined,
                orderNumToSet : number | undefined;

            if ( referencePropertySet.isEnumerated && referencePropertySet.isValueOrdered ) {
                if ( typeof attributes.value !== 'string' ) {
                    throw new LocalizableError(
                        'YN.base.dataObject.property.attributes.validation.value.mustBeStringForValueOrderedEnum'
                    );
                }

                const { orderNum, value } = this.getOrderNumAndValue( attributes.value );

                orderNumToSet = orderNum;
                valueToSet = value;
            }
            else if ( typeof attributes.value === 'string' ) {
                valueToSet = convertValueForType( attributes.value, referencePropertySet.valueType );
            }
            else {
                valueToSet = attributes.value;
            }

            if ( orderNumToSet ) {
                this.validateOrderNum( orderNumToSet );
                this._orderNum = orderNumToSet
            }

            if ( valueToSet !== undefined && valueToSet !== null && valueToSet !== '' ) {
                this.validateValue( valueToSet );
                this._value = valueToSet
            }
        }

        // get new orderNum if needed and no one set (===0)
        if ( this.isNew() && ( referencePropertySet.isKeyOrdered || referencePropertySet.isValueOrdered ) && !this._orderNum && this._parent instanceof EnumReferenceProperty ) {
            this._orderNum = this._parent.getMaxOrderNum() + 1;
        }

        if ( attributes.statusId ) {
            this._statusId = attributes.statusId;
        }
        else {
            this._statusId = parent instanceof Reference
                ? parent.statusId
                : parent.parent.statusId;
        }

        if ( attributes.modifierUserId ) {
            this._modifierUserId = attributes.modifierUserId;
        }
        if ( attributes.modificationTime ) {
            if ( typeof attributes.modificationTime === 'string' ) {
                this._modificationTime = convertToDate( attributes.modificationTime );
            }
            else {
                this._modificationTime = attributes.modificationTime;
            }
        }
        if ( attributes.validatorUserId ) {
            this._validatorUserId = attributes.validatorUserId;
        }
        if ( attributes.validationTime ) {
            if ( typeof attributes.validationTime === 'string' ) {
                this._validationTime = convertToDate( attributes.validationTime );
            }
            else {
                this._validationTime = attributes.validationTime;
            }
        }
        if ( attributes.validFromTime ) {
            if ( typeof attributes.validFromTime === 'string' ) {
                this._validFromTime = convertToDate( attributes.validFromTime );
            }
            else {
                this._validFromTime = attributes.validFromTime;
            }
        }
        if ( attributes.validToTime ) {
            if ( typeof attributes.validToTime === 'string' ) {
                this._validToTime = convertToDate( attributes.validToTime );
            }
            else {
                this._validToTime = attributes.validToTime;
            }
        }

        this._attributesModified = new Map();
    }

    /**
     * Returns an object containing the attributes with their values limited by includeAttributes parameter.
     *
     * @param includeAttributes   The state of the attributes to include in result.
     */
    toJSON( includeAttributes : 'all' | 'modified' = 'all' ) : ReferencePropertyJsonAttributes {
        // required attributes
        const retVal : ReferencePropertyJsonAttributes = {
                  id                    : this._id,
                  referenceId           : this._referenceId,
                  referencePropertySetId: this._referencePropertySetId
              },
              isNew                                    = this.isNew(),
              referencePropertySet                     = this.referencePropertySet;

        if (
            referencePropertySet.isEnumerated && (
                isNew
                || includeAttributes !== 'modified'
                || this._attributesModified.has( 'key' )
                || ( referencePropertySet.isKeyOrdered && this._attributesModified.has( 'orderNum' ) )
            )
        ) {
            retVal.key = this.stringKey;
        }

        if (
            isNew
            || includeAttributes !== 'modified'
            || this._attributesModified.has( 'value' )
            || ( referencePropertySet.isValueOrdered && this._attributesModified.has( 'orderNum' ) )
        ) {
            retVal.value = this.stringValue;
        }

        if (
            isNew
            || includeAttributes !== 'modified'
            || this._attributesModified.has( 'statusId' )
        ) {
            retVal.statusId = this._statusId;
        }

        // not settable attributes
        if ( includeAttributes !== 'modified' ) {
            retVal.modifierUserId = this.modifierUserId;

            // only active attributes
            if ( !this.isHistorized() ) {
                retVal.modificationTime = convertValueToString( this.modificationTime, 'TIMESTAMP' );
                retVal.validatorUserId = this.validatorUserId;
                retVal.validationTime = convertValueToString( this.validationTime, 'TIMESTAMP' );
            }

            // only history attributes
            else {
                retVal.validFromTime = convertValueToString( this._validFromTime, 'TIMESTAMP' );
                retVal.validToTime = convertValueToString( this._validToTime, 'TIMESTAMP' );
            }
        }

        return retVal;
    }

    /**
     * Returns an object containing the attributes with their values limited by includeAttributes parameter.
     *
     * @param includeAttributes   The state of the attributes to include in result.
     */
    toUpdateJSON( includeAttributes : 'all' | 'modified' = 'all' ) : ReferencePropertyAttributesSettable {
        // required attributes
        const retVal : ReferencePropertyAttributesSettable = {},
              isNew                                        = this.isNew(),
              referencePropertySet                         = this.referencePropertySet;

        if (
            referencePropertySet.isEnumerated && (
                isNew
                || includeAttributes !== 'modified'
                || this._attributesModified.has( 'key' )
                || ( referencePropertySet.isKeyOrdered && this._attributesModified.has( 'orderNum' ) )
            )
        ) {
            retVal.key = this.stringKey;
        }

        if (
            isNew
            || includeAttributes !== 'modified'
            || this._attributesModified.has( 'value' )
            || ( referencePropertySet.isValueOrdered && this._attributesModified.has( 'orderNum' ) )
        ) {
            retVal.value = this.stringValue;
        }

        if (
            isNew
            || includeAttributes !== 'modified'
            || this._attributesModified.has( 'statusId' )
        ) {
            retVal.statusId = this._statusId;
        }

        return retVal;
    }

    /**
     * Builds and returns the signature string for this
     */
    toString() : string {
        let retVal : string;

        if ( this._parent instanceof EnumReferenceProperty ) {
            retVal = `ReferenceProperty for key '${this.stringKey}'`;
        }
        else {
            retVal = `ReferenceProperty '${this.referencePropertySet.name}'`;
        }

        retVal += ` of ${this._parent}`;

        return retVal;
    }

    /**
     * Returns a string containing the XML representation of this
     * @param {boolean} [excludeDeleted]
     */
    toXML( excludeDeleted : boolean = false, indent : number = 0 ) : string {
        const referencePropertySet = this.referencePropertySet,
              valueType            = referencePropertySet.valueType;


        let retVal = '';

        if ( !excludeDeleted || !this.isDeleted() ) {
            retVal = `<property name='${encodeHtmlEntities( this.referencePropertySet.name, { level: 'xml' } )}'`.indent( indent );

            if ( this._parent instanceof EnumReferenceProperty ) {
                retVal += ` key='${encodeHtmlEntities( this.stringKey, { level: 'xml' } )}'`;
            }

            retVal += ` status='${encodeHtmlEntities( this.status.name, { level: 'xml' } )}'>`;

            if ( valueType === 'JSON' || valueType === 'STRING' || valueType === 'TEXT' || valueType === 'TIMERULE' ) {
                let xmlValue = this.stringValue;

                // replace ]]> sequence
                xmlValue = xmlValue.replaceAll( /]]>/g, ']]]]><![CDATA[>' );

                retVal += `<![CDATA[${xmlValue}]]>`;
            }
            else {
                retVal += this.stringValue;
            }

            retVal += '</property>';
        }

        return retVal;
    }

    /**
     * Resets all settable attributes to their initial values.
     */
    reset() : ReferenceProperty {
        if ( this._attributesModified.has( 'key' ) ) {
            this._key = this._attributesModified.get( 'key' ) as AttributeValue;
        }
        if ( this._attributesModified.has( 'value' ) ) {
            this._value = this._attributesModified.get( 'value' ) as AttributeValue;
        }
        if ( this._attributesModified.has( 'statusId' ) ) {
            this._statusId = this._attributesModified.get( 'statusId' ) as number;
        }
        if ( this._attributesModified.has( 'orderNum' ) ) {
            this._orderNum = this._attributesModified.get( 'orderNum' ) as number;
        }

        this._attributesModified = new Map();

        return this;
    }

    /**
     * Commits all changes of settable attributes.
     */
    commit( referencePropertyMetaDataMapping? : ReferencePropertyMetaDataMapping ) : ReferenceProperty {

        // update id and metaData if new and mapped one is given
        if ( referencePropertyMetaDataMapping?.[ this._id ] ) {
            this._modifierUserId = referencePropertyMetaDataMapping[ this._id ].modifierUserId;
            this._modificationTime = convertToDate( referencePropertyMetaDataMapping[ this._id ].modificationTime );
            this._validatorUserId = referencePropertyMetaDataMapping[ this._id ].validatorUserId;
            this._validationTime = convertToDate( referencePropertyMetaDataMapping[ this._id ].validationTime );

            if ( this.isNew() ) {
                this._referenceId = referencePropertyMetaDataMapping[ this._id ].referenceId;
                this._id = referencePropertyMetaDataMapping[ this._id ].id;
            }
        }

        this._attributesModified = new Map();

        return this;
    }

    /**
     * Resets the given settable attribute to its initial value.
     *
     * @param {keyof ReferencePropertyAttributesSettable} attribute
     */
    resetAttribute( attribute : keyof ReferencePropertyAttributesSettable ) {
        if ( this._attributesModified.has( attribute ) ) {
            switch ( attribute ) {
                case 'key':
                    this._key = this._attributesModified.get( 'key' ) as string;
                    break;

                case 'value':
                    this._value = this._attributesModified.get( 'value' ) as AttributeValue;
                    break;

                case 'statusId':
                    this._statusId = this._attributesModified.get( 'statusId' ) as number;
                    break;

                case 'orderNum':
                    this._orderNum = this._attributesModified.get( 'orderNum' ) as number;
                    break;
            }

            this._attributesModified.delete( attribute );
        }
    }

    /**
     * Apply given attributes to this reference property.
     *
     * @param attributes An object containing attribute-value pairs to be applied to the clone
     */
    update( attributes : ReferencePropertyAttributesSettable = {} ) : ReferenceProperty {
        const referencePropertySet = this.referencePropertySet;

        // apply data
        if ( attributes.statusId !== undefined && attributes.statusId !== this._statusId ) {
            this.statusId = attributes.statusId;
        }

        if ( attributes.key !== undefined && attributes.key !== null ) {
            let key : AttributeValue;

            if ( referencePropertySet.isKeyOrdered && typeof attributes.key === 'string' && referencePropertySet.keyFromStringRegExp?.exec( attributes.key ) ) {
                let orderNum : number;

                ( { orderNum, key } = this.getOrderNumAndKey( attributes.key ) );

                if ( orderNum !== this._orderNum ) {
                    this.orderNum = orderNum;
                }
            }
            else if ( typeof attributes.key === 'string' ) {
                key = convertValueForType( attributes.key, referencePropertySet.keyType );
            }
            else {
                key = attributes.key;
            }

            if ( key !== this._key ) {
                this.key = key;
            }
        }

        if ( attributes.value !== undefined && attributes.value !== null ) {
            let value : AttributeValue;

            if ( referencePropertySet.isEnumerated && referencePropertySet.isValueOrdered && typeof attributes.value === 'string' && referencePropertySet.valueFromStringRegExp?.exec( attributes.value ) ) {
                let orderNum : number;

                ( { orderNum, value } = this.getOrderNumAndValue( attributes.value ) );

                if ( orderNum !== this._orderNum ) {
                    this.orderNum = orderNum;
                }
            }
            else if ( typeof attributes.value === 'string' ) {
                value = convertValueForType( attributes.value, referencePropertySet.valueType );
            }
            else {
                value = attributes.value;
            }

            if ( value !== this._value ) {
                this.value = value;
            }
        }

        if ( attributes.orderNum !== undefined && attributes.orderNum !== null && attributes.orderNum !== this._orderNum ) {
            this.orderNum = attributes.orderNum;
        }

        return this;
    }

    /**
     * Creates and returns a clone of this with given attributes applied.
     *
     * @param [attributes]          An object containing attribute-value pairs to be applied to the clone
     */
    clone( attributes : ReferencePropertyAttributesSettable = {} ) : ReferenceProperty {
        const clone : ReferenceProperty = omniclone(
            this,
            {
                invokeConstructors: false,
                setPrototype      : true,
                copyGettersSetters: true
            },
            ( node : any ) => {
                // do not clone parent
                if ( node instanceof EnumReferenceProperty || node instanceof Reference ) {
                    return node;
                }
                else {
                    return undefined;
                }
            }
        );

        if ( Object.keys( attributes ).length ) {
            clone.update( attributes );
        }

        return clone;
    }

    /**
     * Checks if this is new.
     */
    isNew() : boolean {
        return this._id < 0;
    }

    /**
     * Checks if this is historized.
     */
    isHistorized() : boolean {
        return this._validFromTime !== null;
    }

    /**
     * Checks if this is deleted.
     */
    isDeleted() : boolean {
        return metaModel[ this._schema ].getDeletedStatus().map( s => s.id ).includes( this._statusId );
    }

    /**
     * Checks if this is modified.
     */
    isModified() : boolean {
        return this._attributesModified.size > 0;
    }

    /**
     * Checks if this is valid.
     */
    isValid() : boolean {
        let retVal = true;

        const referencePropertySet = this.referencePropertySet;

        // new
        if ( this.isNew() ) {
            // key settable and empty
            if ( referencePropertySet.isKeySettable && this._key === '' ) {
                retVal = false;
            }
            // key not settable and not empty
            else if ( !referencePropertySet.isKeySettable && this._key !== '' ) {
                retVal = false;
            }

            // value settable and empty
            if ( referencePropertySet.isValueSettable && this._value === '' ) {
                retVal = false;
            }
            // value not settable and not empty
            else if ( !referencePropertySet.isValueSettable && this._value !== '' ) {
                retVal = false;
            }

            // orderNum settable and zero
            if ( ( referencePropertySet.isKeyOrdered || referencePropertySet.isValueOrdered ) && this._orderNum === 0 ) {
                retVal = false;
            }
            // orderNum not settable and not zero
            else if ( !referencePropertySet.isKeyOrdered && !referencePropertySet.isValueOrdered && this._orderNum !== 0 ) {
                retVal = false;
            }

            // deleted
            if ( this.isDeleted() ) {
                retVal = false;
            }
        }

        // modified
        else {
            // key is modified and settable and empty
            if ( this.isAttributeModified( 'key' ) && referencePropertySet.isKeySettable && this._key === '' ) {
                retVal = false;
            }
            // key is modified and not settable and not empty
            else if ( this.isAttributeModified( 'key' ) && !referencePropertySet.isKeySettable && this._key !== '' ) {
                retVal = false;
            }

            // value is modified and settable and empty
            if ( this.isAttributeModified( 'value' ) && referencePropertySet.isValueSettable && this._value === '' ) {
                retVal = false;
            }
            // value is modified and not settable and not empty
            else if ( this.isAttributeModified( 'value' ) && !referencePropertySet.isValueSettable && this._value !== '' ) {
                retVal = false;
            }

            // orderNum is modified and settable and zero
            if ( this.isAttributeModified( 'orderNum' ) && ( referencePropertySet.isKeyOrdered || referencePropertySet.isValueOrdered ) && this._orderNum === 0 ) {
                retVal = false;
            }
            // orderNum is modified and not settable and not zero
            else if ( this.isAttributeModified( 'orderNum' ) && !referencePropertySet.isKeyOrdered && !referencePropertySet.isValueOrdered && this._orderNum !== 0 ) {
                retVal = false;
            }

            // deleted and modified
            if ( this.isDeleted() && ( this.isAttributeModified( 'key' ) || this.isAttributeModified( 'value' ) || this.isAttributeModified( 'orderNum' ) ) ) {
                retVal = false;
            }
        }

        return retVal;
    }

    /**
     * Checks if the given attribute is modified or not.
     *
     * @param attribute        The attribute to check if it is modified
     */
    isAttributeModified( attribute : keyof ReferencePropertyAttributesSettable ) : boolean {
        return this._attributesModified.has( attribute );
    }

    /**
     * Gets if the (original) unmodified value for given attribute is modified .
     *
     * @param attribute        The attribute to get value for
     */
    getAttributeOriginalValue( attribute : keyof ReferencePropertyAttributesSettable ) : AttributeValue {
        return this._attributesModified.get( attribute ) ?? this[ attribute ];
    }

    protected getOrderNumAndKey( stringKey : string ) : { orderNum : number; key : AttributeValue; } {
        const retVal : { orderNum : number; key : AttributeValue; } = {
                  orderNum: 0,
                  key     : ''
              },
              referencePropertySet                                  = this.referencePropertySet,
              keyFromStringRegExp                                   = referencePropertySet.keyFromStringRegExp;

        if ( keyFromStringRegExp ) {
            const match = keyFromStringRegExp.exec( stringKey );

            if ( match ) {
                retVal.orderNum = Number( match.groups?.orderNum ?? '0' );
                retVal.key = convertValueForType( match.groups?.key ?? '', referencePropertySet.keyType );
            }
            else {
                throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.doesntMatchKeyDefinition' );
            }
        }
        else {
            retVal.key = convertValueForType( stringKey ?? '', referencePropertySet.keyType );
        }

        return retVal
    }

    protected getOrderNumAndValue( stringValue : string ) : { orderNum : number; value : AttributeValue; } {
        const retVal : { orderNum : number; value : AttributeValue; } = {
                  orderNum: 0,
                  value   : ''
              },
              referencePropertySet                                    = this.referencePropertySet,
              valueFromStringRegExp                                   = referencePropertySet.valueFromStringRegExp;

        if ( valueFromStringRegExp ) {
            const match = valueFromStringRegExp.exec( stringValue );

            if ( match ) {
                retVal.orderNum = Number( match.groups?.orderNum ?? '0' );
                retVal.value = convertValueForType( match.groups?.value ?? '', referencePropertySet.valueType );
            }
            else {
                throw new LocalizableError( 'YN.base.dataObject.property.attributes.validation.value.doesntMatchValueDefinition' );
            }
        }
        else {
            retVal.value = convertValueForType( stringValue ?? '', referencePropertySet.valueType );
        }

        return retVal
    }

    /**
     * Handles the modified attributes list.
     *
     * @param attribute         The attribute
     * @param value             The value for the attribute
     */
    protected handleModified( attribute : keyof ReferencePropertyAttributesSettable, value : AttributeValue ) {
        const valueType            = this.referencePropertySet.valueType,
              compareValue         = attribute === 'key' || attribute === 'value'
                  ? convertValueToString( value, valueType )
                  : value,
              currentCompareValue  = attribute === 'key' || attribute === 'value'
                  ? convertValueToString( this[ attribute ], valueType )
                  : this[ attribute ],
              modifiedCompareValue = attribute === 'key' || attribute === 'value'
                  ? convertValueToString( this._attributesModified.get( attribute )!, valueType )
                  : this._attributesModified.get( attribute );

        // set as modified
        if ( !this._attributesModified.has( attribute ) && compareValue !== currentCompareValue ) {
            this._attributesModified.set( attribute, this[ attribute ] );
        }

        // unset as modified
        else if ( this._attributesModified.has( attribute ) && compareValue === modifiedCompareValue ) {
            this._attributesModified.delete( attribute );
        }
    }

    protected checkStatus() {
        if ( this.isDeleted() ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.couldNotChangeDeleted', undefined, undefined, undefined, 40111 );
        }
        else if (
            ( this._parent instanceof Reference && this._parent.isDeleted() )
            || ( this._parent instanceof EnumReferenceProperty && this._parent.parent.isDeleted() )
        ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.couldNotChangeOfDeleted', undefined, undefined, undefined, 40112 );
        }
    }

    /**
     * Validates the given statusId
     */
    protected validateStatusId( statusId : number ) {
        if ( !metaModel[ this._schema ].getStatus( statusId ) ) {
            throw new LocalizableError( 'YN.base.dataObject.common.attribute.validation.statusId.notExists', undefined, undefined, undefined, 40121 );
        }

        if (
            (
                statusId === metaModel[ this._schema ].getStatus( 'history' )?.id
                || statusId === metaModel[ this._schema ].getStatus( 'deleted' )?.id
            )
            && (
                this._attributesModified.size > 1
                || ( this._attributesModified.size === 1 && !this._attributesModified.has( 'statusId' ) )
            )
        ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.couldNotDeleteChanged', undefined, undefined, undefined, 40122 );
        }
    }

    /**
     * Validates the key for this
     */
    protected validateKey( key : AttributeValue ) {
        this.checkStatus();

        // enumerated
        if ( this._parent instanceof Reference ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.notEnumerated', undefined, undefined, undefined, 40131 );
        }

        // settable
        if ( !this.referencePropertySet.isKeySettable ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.notSettable', undefined, undefined, undefined, 40132 );
        }
        // empty
        else if ( key === undefined || key === null || key === '' ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.isEmpty', undefined, undefined, undefined, 40133 );
        }

        // unique
        if ( this._parent instanceof EnumReferenceProperty && !this._parent.isKeyUnique( key, this ) ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.isNotUnique', undefined, undefined, undefined, 40134 );
        }

        // stringKey length
        if ( this.referencePropertySet.getStringKey( { key, orderNum: this._orderNum } ).length > 255 ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.tooLong' );
        }

        try {
            validateValueForType( key, this.referencePropertySet.keyType, true );
        }
        catch ( e ) {
            if ( e instanceof Error ) {
                throw new LocalizableError( e.name, undefined, undefined, undefined, 40136 );
            }
        }
    }

    /**
     * Validates the value of this
     */
    protected validateValue( value : AttributeValue ) {
        this.checkStatus();

        const referencePropertySet = this.referencePropertySet,
              valueSet             = referencePropertySet.valueSet,
              valueType            = referencePropertySet.valueType;

        // settable
        if ( !referencePropertySet.isValueSettable ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.value.notSettable', undefined, undefined, undefined, 20142 );
        }
        // empty
        else if ( value === undefined || value === null || value === '' ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.value.empty', undefined, undefined, undefined, 40143 );
        }

        if ( valueSet ) {
            const rawValueSetValues = valueSet.values,
                  valueSetValues    = rawValueSetValues.map( ( valueSetValue : Value ) => {
                      return convertValueForType( valueSetValue.value, valueType );
                  } );

            if ( !valueSetValues.includes( value ) ) {
                throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.value.doesntMatchValueSet', { value: String( value ) }, undefined, undefined, 40145 );
            }
        }

        try {
            validateValueForType( value, valueType, true );
        }
        catch ( e ) {
            if ( e instanceof LocalizableError ) {
                e.number = 40146;
                throw e;
            }
            else if ( e instanceof Error ) {
                throw new LocalizableError( e.name, undefined, undefined, undefined, 40146 );
            }
        }

        if ( referencePropertySet.valueMin && value < convertValueForType( referencePropertySet.valueMin, valueType )! ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.value.lesserThanValueMin', { value: String( value ), valueMin: String( referencePropertySet.valueMin ) }, undefined, undefined, 40147 );
        }
        if ( referencePropertySet.valueMax && value > convertValueForType( referencePropertySet.valueMax, valueType )! ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.value.greaterThanValueMax', { value: String( value ), valueMin: String( referencePropertySet.valueMin ) }, undefined, undefined, 40148 );
        }
    }

    /**
     * Validates the orderNum of this
     */
    protected validateOrderNum( orderNum : number ) {
        const referencePropertySet = this.referencePropertySet;

        this.checkStatus();

        // enumerated
        if ( this._parent instanceof Reference || ( !referencePropertySet.isKeyOrdered && !referencePropertySet.isValueOrdered ) ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.orderNum.notSortedEnumerated', undefined, undefined, undefined, 40151 );
        }

        // stringKey length
        if ( this.referencePropertySet.getStringKey( { key: this._key, orderNum } ).length > 255 ) {
            throw new LocalizableError( 'YN.base.dataObject.referenceProperty.attributes.validation.key.tooLong' );
        }
    }
}

export default ReferenceProperty;
